import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { Toaster } from "./ui/sonner";

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-[color:var(--ssm-text)]">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <Toaster position="top-center" richColors={false} />
    </div>
  );
};

const AnnouncementBar = () => (
  <div
    data-testid="announcement-bar"
    className="bg-black text-white text-[11px] uppercase tracking-[0.25em] py-2 text-center"
  >
    Free worldwide shipping on orders over $100 · 30-day returns
  </div>
);
